import { render, staticRenderFns } from "./RegisterMain.vue?vue&type=template&id=8aa61aaa&scoped=true"
import script from "./RegisterMain.vue?vue&type=script&lang=js"
export * from "./RegisterMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa61aaa",
  null
  
)

export default component.exports